/**
 * The console's antd tokens (QC_THEME in
 * features/QueryConsole/components/qcTheme.ts), so the dashboard's controls
 * match the console's. The workspace applies them, and so do dialogs that
 * render outside it (the filter definitions). The brand colour and the button
 * look come from the app theme (theme/dataqTheme.ts).
 */
export const WORKSPACE_THEME = {
  token: {
    colorText: "#1A1817",
    colorTextSecondary: "#5C544B",
    colorBgContainer: "#FFFFFF",
    borderRadius: 4,
    fontFamily: '"General Sans", system-ui, sans-serif',
    controlItemBgHover: "rgba(54, 195, 237, 0.10)",
    controlItemBgActive: "rgba(54, 195, 237, 0.18)",
    controlItemBgActiveHover: "rgba(54, 195, 237, 0.22)",
  },
}
